























import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import VIcon from "@/components/VIcon.vue";

export type StepItem = {
  key: string;
  label: string;
  index: number;
};
@Component({
  components: {
    VIcon,
  },
})
export default class VVerticalSteps extends Vue {
  @Prop({ required: true }) readonly steps!: StepItem[];
  @Prop() readonly currentStep?: string;
  @Prop({ default: false }) readonly enableSkip!: boolean;
  @Prop({ default: () => [] }) readonly disabledSteps!: string[];

  current: string | null = null;

  created() {
    this.current = this.currentStep ?? this.steps[0].key;
  }

  @Watch("currentStep", { immediate: true })
  onCurrentStepUpdated(val: string) {
    this.current = val;
    this.$emit("changed", this.current);
  }

  isCurrentStep(step: StepItem): boolean {
    return this.currentStep === step.key;
  }

  isLocked(step: StepItem): boolean {
    if (this.disabledSteps.includes(step.key)) return true;
    const currentIndex = this.steps.findIndex(
      (s: StepItem) => s.key == this.currentStep
    );
    const stepIndex = this.steps.indexOf(step);
    return !this.enableSkip && stepIndex >= currentIndex;
  }

  goToStep(step: StepItem) {
    if (!this.isLocked(step)) {
      this.current = step.key;
      this.$emit("changed", this.current);
    }
  }
}
